import { render, staticRenderFns } from "./NetworkTrafficGraph.vue?vue&type=template&id=23381ffa"
import script from "./NetworkTrafficGraph.vue?vue&type=script&lang=js"
export * from "./NetworkTrafficGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports